export enum CaseProgressType {
  PreLegal = 1,
  Reminder = 2,
  Legal = 3,
  Surveillance = 4,
  Invoice = 5,
}
